export const questions = [
    {
        "key": "driversLicenseNumber",
        "question": "Drivers License Number"
    },
    {
        "key":"firstName",
        "question": "First Name"
    },
    {
        "key":"lastName",
        "question": "Last Name"
    },
    {
        "key":"phoneNumber",
        "question": "Phone Number"
    },
    
    {"key":"address","question":"Address"},
    {
        "key":"email",
        "question": "Email"
    },
    {
        "key":"dob",
        "question": "Date of Birth"

    },{
        "key":"abnNumber",
        "question": "ABN Number"
    },
    {
        "key":"fullLicenseNSW",
        "question": "Have you had your Full License in NSW for more than 1 year"
    },
    {
        "key":"licenseExpiry",
        "question": "License Expiry"
    },
    {
        "key":"previousState",
        "question": "If you have not had your license in NSW for more than 1 year, but had your license in another Australian State or Territory please attach your driving history"
    },
    {
        "key":"drivingHistory",
        "question": "Please attach a copy of your NSW Driving History Report"
    },
    {
        "key":"licenseFront",
        "question": "Photo of the front of your NSW license"
    },{
        "key":"licenseRear",
        "question": "Photo of the rear of your NSW license"
    },{
        "key":"emergencyContactName",
        "question": "Emergency Contact Name"
    },{
        "key":"emergencyContactNumber",
        "question": "Emergency Contact Number"
    },{
        "key":"emergencyContactRelation",
        "question": "Emergency Contact Relation"
    },{
        "key":"criminalHistoryCheck",
        "question": "Please attach a photo of your Criminal History Check."
    },{
        "key":"taxiDriverAuthority",
        "question": "Please attach a photo of any other Taxi Driver Authority if any."
    },{
        "key":"photo",
        "question": "Please attach a photo of yourself. THIS PHOTO MUST BE TAKEN AGAINST A WHITE WALL."

    },{
        "key":"fee",
        "question": "The Opera Taxis Driver ID fee is $30 for 1 year."
    },{
        "key": "obligation1",
        "question": "All drivers must meet certain safety standards such as holding an unrestricted driver licence for 12 months in the preceding two years and meeting medical standards. Safety standards for drivers are outlined further here."
    },
    {
        "key": "obligation2",
        "question": "Drivers must be logged into the Opera Taxis App and SmartMove Go App in the tablet installed in the car whilst on duty/ready for hire."
    },
    {
        "key": "obligation3",
        "question": "Taxi drivers must not smoke/vape in their vehicle at any time."
    },
    {
        "key": "obligation4",
        "question": "Drivers must not behave in an offensive manner and must not interfere with the comfort or safety of others."
    },
    {
        "key": "obligation5",
        "question": "Drivers’ blood alcohol concentration must be under 0.02 grams of alcohol per 100 ml of blood."
    },
    {
        "key": "obligation6",
        "question": "Drivers must not damage a vehicle or interfere with its equipment and drivers must not drive a vehicle that they know, or ought reasonably to know, is non-compliant with the Regulations."
    },
    {
        "key": "obligation7",
        "question": "Drivers cannot prohibit any assistance animals or assistance animals in training from entering the vehicle."
    },
    {
        "key": "obligation8",
        "question": "Drivers, or any other person, must not tout or solicit for passengers for the hiring of a vehicle."
    },
    {
        "key": "obligation9",
        "question": "In Airport precincts, drivers must only pick up or drop off passengers in the designated areas. Drivers must not leave their vehicle unattended unless in a designated holding bay. Drivers must follow the directions of airport security and staff."
    },
    {
        "key": "obligation10",
        "question": "Drivers must follow the reasonable directions of the authorised officers of the Point to Point Transport Commissioner, police officers, or officers authorised under transport law. Drivers must hand over their driver's licence for inspection if requested to do so by an authorised officer or the police."
    },
    {
        "key": "obligation11",
        "question": "Drivers must only accept bookings from authorised booking service providers."
    },
    {
        "key": "obligation12",
        "question": "Drivers must comply with directions given by taxi or booking service providers in the course of collecting the levy."
    },
    {
        "key": "obligation13",
        "question": "Drivers are only allowed to stop in an area that is not a taxi zone if they are hired or not available for hire, loading or unloading luggage or goods, or picking up and dropping off passengers. If a taxi is hired or vacant a driver cannot stop in a taxi zone."
    },
    {
        "key": "obligation14",
        "question": "Taxi drivers must not interfere or permit interference with a taxi’s tracking device, camera, fare calculation device, or duress alarm."
    },
    {
        "key": "obligation15",
        "question": "The driver of a taxi that is available for hire must accept a hiring immediately when offered. Taxi drivers can only refuse to pick up a passenger if: it would breach the Road Rules 2014, a driver is finishing their shift and the passenger wishes to go to a location not on the way to the driver’s destination, the passenger is traveling to a location outside the taxi’s area of operation, the person is smoking or drinking alcohol and refuses to stop, the person is likely to damage or soil the taxi or other passengers, or cause inconvenience, offend, annoy or interfere with the comfort or safety of other passengers or the driver, one of the passengers is under the age of one year and neither driver nor passengers is carrying an appropriate child restraint, the passenger, on request, cannot pay the fare in the case of a pre-paid fare, the agreed deposit has not been paid."
    },
    {
        "key": "obligation16",
        "question": "Taxi drivers must display their identity document clearly."
    },
    {
        "key": "obligation17",
        "question": "For a taxi hiring using the meter, the driver must start the fare calculation device (meter) as soon as the taxi is hired and keep the meter running during the hiring. The meter must be stopped once the hiring has ended or if the taxi is delayed because of a fuel shortage or other reason in the driver’s control."
    },
    {
        "key":"codeOfConduct",
        "question": "I have read the code of conduct."
    },
    {
        "key":"driverTraining",
        "question": "I have read the driver training manual and will act accordingly."
    },
    {
        "key":"duressTraining",
        "question": "I have read the duress training and will act accordingly."
    },
    {
        "key":"smartMoveFeatures",
        "question": "I have watched the SmartMove Go Features video."
       },
    {
        "key":"Complaint",
        "question":"I have read and understood the Complaint Handling Procedure",
    },
    {
        "key":"vehicleMaintenanceTraining",
        "question":"I have read and understood the Vehicle Maintaince Policy and will maintain my vehicle according to company standards",
    },
    
    {"key":"safetyTraining",
        "question":"I have read and understood the Drug and Alchol Policy"
    },
    {"key":"complianceTraining",
        "question":"I have read and understood the Incident Management Policy."
    },

   
   {
    "key":"understandAssistanceAnimal",
    "question": "I understand I cannot refuse passengers with assistance animal"
   },
   {
    "key":"customerServiceTraining",
    "question": "I have read and understood the Fatigue Management Policy"
   },
   
   {
    "key": "0",
    "question": "Is it OK to refuse a fare if the fare is only a short one?"
},
{
    "key": "1",
    "question": "Which of the following is an example of good customer service?"
},
{
    "key": "2",
    "question": "What is the blood alcohol limit for taxi drivers?"
},
{
    "key": "3",
    "question": "As a taxi driver who do you have a duty of care to?"
},
{
    "key": "4",
    "question": "If you notice a safety hazard in your vehicle what should you do?"
},
{
    "key": "5",
    "question": "Which of the options is an appropriate question to ask a passenger?"
},
{
    "key": "6",
    "question": "What is a good way to prevent stress and anger?"
},
{
    "key": "7",
    "question": "Which documents regulate what taxi drivers can and can’t do?"
},
{
    "key": "8",
    "question": "Irritability and sore eyes might tell you it’s time to..."
},
{
    "key": "9",
    "question": "Is this statement true or false? Opera Taxis can search a driver by asking them to empty their pockets, open bags or jackets to look for drugs and alcohol."
},
// {
//     "key": "consent",
//     "question": "I give consent to Opera Taxis Taxi Network"
// }
]
        
    
   
   
    
